import { DropdownIndicatorProps, components } from 'react-select';
import { IconColorE } from '../../../../models/enums';
import Icon from '../../../Icon/Icon';

const DropdownIndicator = (props: DropdownIndicatorProps) => {
    return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            <Icon name="selectArrow" color={IconColorE.WHITE} />
          </components.DropdownIndicator>
        )
      );
};

export default DropdownIndicator;